import React from "react";
import MainViewLayout from "../layout/MainViewLayout";

export default function AllProduct() {
  return (
    <MainViewLayout>
      <h2>All Product</h2>
      <p>You will see all product list in this page.</p>
    </MainViewLayout>
  );
}
